module.exports = __webpack_public_path__ + "img/85.12fa883.png";